import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      ratesTotal: 'rates/getTotal',
      mobileNetworksTotal: 'mobileNetwork/getTotal',
    }),
  },
  methods: {
    ...mapActions({
      viewRates: 'rates/getRateList', 
      viewMobileNetworks: 'mobileNetwork/GetMobileNetworks',
    }),
    async getRateList(operator, rateType) {  
      var params = { type: 'vendor rate', rate_table_type: rateType};
  
      if(rateType === 'prefix' && operator.code) {
        let index = operator.code.indexOf('-');
        
        if(index > -1 && operator.code[index + 1]) {
          params.code = '[' + operator.code + ']'
        } else {
          params.code = operator.code;
        }
      } else if(rateType === 'MNCMCC' && operator.mobile_network_uuid) {
        params.mobileNetworkId = operator.mobile_network_uuid
      } else {
        return
      }
       
      await this.viewRates(params);
  
      params.per_page = this.ratesTotal;
      return await this.viewRates(params);
    },    

    getMobileNetworkList:async function(code) {
      await this.viewMobileNetworks({ country_code: code });
      await this.viewMobileNetworks({ per_page: this.mobileNetworksTotal, country_code: code });
    },
  },
}